
import { Vue, Component, Prop } from "vue-property-decorator";

import CalendarAdmin from "../calendar/AdminCalendar.vue";
import CalendarManager from "../calendar/ManagerCalendar.vue";
import { Company, User } from "@/generated/graphql";
import Roles from "@/entities/Roles";

@Component({
  components: {
    CalendarAdmin,
    CalendarManager,
  },
})
export default class ContractorPublicPage extends Vue {
  @Prop({ type: Object, required: true }) readonly currentUser!: User;
  @Prop({ type: Object, required: true }) readonly company!: Company;

  get isAdmin(): boolean {
    return this.currentUser.role === Roles.ADMIN;
  }

  get currentUserManagerId(): string {
    return this.currentUser.manager!.id;
  }
}
